export const formatCanadaPostalCode = (postalCode: string | null) => {
  const code = postalCode?.replace(/\s/g, '').toLocaleUpperCase();

  return code ? `${code.slice(0, 3)} ${code.slice(3)}` : postalCode;
};
